export const reflectionQuestions = {
  success: [
    "How did you end up solving the problem?",
    "Why do you think your solution was correct/incorrect?",
    "What did you learn from solving this problem?",
    "Was this problem easy or hard for you? Why?",
    "Was there anything particularly difficult about this problem? If so, how did you solve it?",
    "Is there any part of the problem you still find confusing?",
    "Which programming concepts did you use in your solution?",
    "Are there any programming concepts you think you need to practice more?",
    "How long did it take you to solve this problem? If you could go back in time, what would you do differently to solve this quicker?",
    "How was this solution different from your last one?",
    "How does this problem compare to the last one you did? Why?"
  ],
  fail: [
    "What do you think is the problem with your solution?",
    "You got a few test cases right. Why do you think some test cases pass and the others don't?",
  ]
}
